import React from 'react';
import { FaTrashAlt } from 'react-icons/fa';

const FileUpload = ({
  files,
  label,
  handleFileUpload,
  fileType,
  Icon,
  handleRemoveFile,
  multiple = false,
}) => {

  const normalizeFiles = () => {
    if (!files) return [];

    // multiple files
    if (multiple && Array.isArray(files)) return files;

    // single file (File or URL)
    if (!multiple && (files instanceof File || typeof files === 'string')) {
      return [files];
    }

    return [];
  };

  const normalizedFiles = normalizeFiles();

  const isImage = (file) => {
    if (file?.type?.startsWith('image/')) return true;
    if (typeof file === 'string' && file.startsWith('http')) return true;
    return false;
  };

  return (
    <div className="flex flex-col items-start w-full border p-4 rounded-lg shadow-md bg-white mb-4">

      <input
        type="file"
        id={fileType}
        accept="image/*"
        multiple={multiple}
        onChange={(e) => handleFileUpload(e, fileType)}
        className="hidden"
      />

      <label
        htmlFor={fileType}
        className="flex items-center space-x-2 cursor-pointer border p-2 rounded-lg hover:border-primeColor"
      >
        {Icon}
        {label}
      </label>

      <div className="flex flex-wrap gap-2 mt-2">
        {normalizedFiles.map((file, index) => (
          <div key={index} className="relative">
            {isImage(file) && (
              <>
                <img
                  src={typeof file === 'string'
                    ? file
                    : URL.createObjectURL(file)
                  }
                  alt="preview"
                  className="w-[50px] h-[50px] object-cover rounded border"
                />

                {handleRemoveFile && (
                  <button
                    type="button"
                    onClick={() => handleRemoveFile(fileType, index)}
                    className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-1"
                  >
                    <FaTrashAlt size={12} />
                  </button>
                )}
              </>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FileUpload;
